import script from "./AlertAcceptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertAcceptModal.vue?vue&type=script&setup=true&lang=js"

import "./AlertAcceptModal.vue?vue&type=style&index=0&id=1a5844bf&lang=scss"

const __exports__ = script;

export default __exports__